import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Translate } from 'react-i18nify';
import HomePage from '../../components/Home/Home';

const AuthenticatedRoutes = () => (
  <Switch>
    <Route exact path="/dashboard" component={HomePage} />
  </Switch>
);

export default AuthenticatedRoutes;
